import moment from 'moment-timezone'

export const formatDate = (date) => date.format('YYYY-MM-DD HH:mm:ss')
export const formatQueryDate = (date) => date.format('YYYYMMDDHHmmss')

export const getTzDate = (date, lang) => {
  switch (lang) {
    case 'us':
      return moment(date).tz('America/Los_Angeles')
    case 'zh-tw':
      return moment(date).tz('Asia/Taipei')
    default:
      return moment(date)
  }
}

export const serverTime = (lang) => (date) => {
  const tzDate = getTzDate(date, lang)
  return formatDate(tzDate)
}

export const getServerDateTime = serverTime(process.env.VUE_APP_LANG)

export const getLocalDateTime = (date) => formatDate(moment(date))
export const getLocalDateTimeQuery = (date) => formatQueryDate(moment(date))
